import ApiService from '../api.service'

export const funcao_api = new ApiService<never, string, never>('funcoes')
